import { buildSavePrepPayload, createDraftSavePayloadCache } from "./save-prep-scopes"
import { resolveHasCompareChanges } from "authoring/routes/project/scoped-schedules/lib/resolve-has-compare-changes"
import { getBrowserAuthoringNormalizers } from "./browser-authoring-normalizers"

export { buildSavePrepPayload, createDraftSavePayloadCache, resolveHasCompareChanges }

/**
 * @param {object} params
 * @returns {object | null}
 */
export function runSavePrep(params) {
    return buildSavePrepPayload(params)
}

/**
 * @param {object} params
 * @returns {boolean | null}
 */
export function runCompare({ normalizers, ...params }) {
    return resolveHasCompareChanges({
        ...params,
        normalizers: normalizers ?? getBrowserAuthoringNormalizers(),
    })
}

export function getMainThreadAuthoringNormalizers() {
    return getBrowserAuthoringNormalizers()
}
